<template>
  <article class="benefits-banner-item">
    <button class="benefits-banner-drag-handle" type="button" :aria-label="t('benefitsCenter-banners-dragHandle')"
      tabindex="-1">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </button>

    <img v-if="banner.previewUrl" class="benefits-banner-image" :src="banner.previewUrl" :alt="banner.name" />

    <div v-else class="benefits-banner-image-placeholder" aria-hidden="true"></div>

    <div class="benefits-banner-info">
      <strong>{{ banner.name }}</strong>

      <span :class="['benefits-banner-status', `status-${banner.status}`]">
        {{ statusLabel }}
      </span>
    </div>

    <div class="benefits-banner-actions">
      <button class="benefits-banner-action-button" type="button" :aria-label="linkActionLabel" :title="linkActionLabel"
        @click.stop="$emit('edit-link', index)" @mousedown.stop>
        <Icon icon-class="ui-link-01" size="4" color="#111927" />
      </button>

      <button class="benefits-banner-action-button benefits-banner-action-button-danger" type="button"
        :aria-label="t('benefitsCenter-banners-deleteAction')" :title="t('benefitsCenter-banners-deleteAction')"
        @click.stop="$emit('delete', index)" @mousedown.stop>
        <Icon icon-class="ui-trash-01" size="4" color="#f04438" />
      </button>
    </div>
  </article>
</template>

<script>
import Icon from "../../../components/icon/icon";

export default {
  name: "BenefitsBannerItem",
  components: {
    Icon,
  },
  props: {
    banner: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  computed: {
    linkActionLabel() {
      return this.t(
        this.banner.link
          ? "benefitsCenter-banners-editLinkAction"
          : "benefitsCenter-banners-addLinkAction"
      );
    },
    statusLabel() {
      const statusMap = {
        completed: "benefitsCenter-banners-statusCompleted",
        uploading: "benefitsCenter-banners-statusUploading",
        error: "benefitsCenter-banners-statusError",
      };

      if (!this.banner.status || !statusMap[this.banner.status]) return "";

      return this.t(statusMap[this.banner.status]);
    },
  },
  methods: {
    t(term, replaces) {
      return this.$root.t(term, replaces);
    },
  },
};
</script>

<style lang="scss" scoped>
.benefits-banner-item {
  align-items: center;
  background: #f9fafb;
  border: 1px solid #d2d6db;
  border-radius: 16px;
  cursor: grab;
  display: flex;
  gap: 8px;
  min-height: 76px;
  padding: 8px;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease;
  width: 100%;

  &:active {
    cursor: grabbing;
  }
}

.benefits-banner-drag-handle {
  background: transparent;
  border: 0;
  cursor: grab;
  display: grid;
  flex: 0 0 14px;
  gap: 2px;
  grid-template-columns: repeat(2, 2px);
  justify-content: center;
  padding: 0;

  span {
    background: #9da4ae;
    border-radius: 50%;
    height: 2px;
    width: 2px;
  }
}

.benefits-banner-image,
.benefits-banner-image-placeholder {
  border-radius: 8px;
  flex: 0 0 107px;
  height: 60px;
  object-fit: cover;
  width: 107px;
}

.benefits-banner-image-placeholder {
  background: #e5e7eb;
}

.benefits-banner-info {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 8px;
  justify-content: center;
  min-width: 0;

  strong {
    color: #1f2a37;
    font-family: "Sora", sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 1.3;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.benefits-banner-actions {
  align-items: center;
  display: flex;
  flex: 0 0 auto;
  gap: 8px;
  margin-left: auto;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.15s ease, visibility 0.15s ease;
  visibility: hidden;
}

.benefits-banner-item:hover .benefits-banner-actions,
.benefits-banner-item:focus-within .benefits-banner-actions {
  opacity: 1;
  pointer-events: auto;
  visibility: visible;
}

.benefits-banner-action-button {
  align-items: center;
  background: transparent;
  border: 0;
  border-radius: 8px;
  cursor: pointer;
  display: inline-flex;
  height: 32px;
  justify-content: center;
  padding: 0;
  transition: background 0.15s ease;
  width: 32px;

  &:hover,
  &:focus {
    background: #eef2f6;
    outline: none;
  }
}

.benefits-banner-action-button-danger {
  background: #fee4e2;

  &:hover,
  &:focus {
    background: #fecdca;
  }
}

.benefits-banner-status {
  color: #6c737f;
  font-family: "Inter", sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.2;

  &.status-completed {
    color: #17b26a;
  }

  &.status-error {
    color: #f04438;
  }
}

@media (hover: none),
(max-width: 767px) {
  .benefits-banner-actions {
    opacity: 1;
    pointer-events: auto;
    visibility: visible;
  }

  .benefits-banner-info strong {
    white-space: normal;
    overflow-wrap: anywhere;
  }
}

@media (max-width: 480px) {
  .benefits-banner-image,
  .benefits-banner-image-placeholder {
    flex-basis: 82px;
    height: 48px;
    width: 82px;
  }

  .benefits-banner-info strong {
    white-space: normal;
    overflow-wrap: anywhere;
  }

  .benefits-banner-actions {
    gap: 4px;
  }
}
</style>
